import { render, staticRenderFns } from "./ChooseSomeoneDetial.vue?vue&type=template&id=b1a01ace&scoped=true"
import script from "./ChooseSomeoneDetial.vue?vue&type=script&lang=js"
export * from "./ChooseSomeoneDetial.vue?vue&type=script&lang=js"
import style0 from "./ChooseSomeoneDetial.vue?vue&type=style&index=0&id=b1a01ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a01ace",
  null
  
)

export default component.exports